import { Graphics } from "pixi.js"

/** Small readable iron bomb: a round body, metal collar and visibly burning fuse. */
export const drawBomb = (art: Graphics, x: number, y: number, now: number, flash = false, opacity = 1) => {
    art.lineStyle(1.5, 0x080b0f, opacity)
    art.beginFill(flash ? 0x9c4826 : 0x232a34, opacity)
    art.drawCircle(x, y, 7)
    art.endFill()
    art.lineStyle(0)
    art.beginFill(0x72808e, 0.85 * opacity)
    art.drawEllipse(x - 2, y - 2, 2, 3)
    art.drawRect(x - 2, y - 9, 4, 3)
    art.endFill()
    art.lineStyle(2, 0xd8b77c, opacity)
    art.moveTo(x, y - 8); art.lineTo(x + 3, y - 12); art.lineTo(x + 6, y - 11)
    const pulse = 1 + Math.sin(now / 65) * 0.4
    art.lineStyle(0)
    art.beginFill(0xffb942, opacity)
    art.drawCircle(x + 6, y - 11, 2 * pulse)
    art.endFill()
}

/** Electricity gathers into a translucent silhouette, then resolves into solid iron. */
export const drawMaterializingBomb = (art: Graphics, x: number, y: number, now: number, progress: number) => {
    const t = Math.max(0, Math.min(1, progress / 0.7))
    const opacity = t * t * (3 - 2 * t)
    drawBomb(art, x, y, now, false, opacity)
    const forming = 1 - opacity
    if (forming <= 0) return
    art.lineStyle(1, 0xc4f5ff, forming * 0.6)
    art.drawCircle(x, y, 7)
    art.lineStyle(0)
    for (let i = 0; i < 8; i++) {
        const phase = (now / 600 + i / 8) % 1
        const angle = i * Math.PI / 4 + Math.sin(now / 150 + i) * 0.2
        const radius = 7 + (1 - phase) * 9 * forming
        art.beginFill(i % 2 ? 0xd7f7ff : 0x358dff, forming * phase * 0.8)
        art.drawRect(x + Math.cos(angle) * radius - 0.5, y + Math.sin(angle) * radius - 0.5, 1.5, 1.5)
        art.endFill()
    }
}
